import { request } from './index';
import axios from '@/axios';
 
export async function getBloodList(item) {
 
    let routeName; 
    routeName = 'donor/blood_group_list'; 

    try {
        const { data } = await axios.get(routeName, {
            params: {
                name: item.name ?? '',
                factor: item.factor ?? '',
                kind_of_donor: item.kind_of_donor ?? '',
                unity: item.unity ?? ''
            }
        });

        return data.data;
    } catch (error) {
        return error;
    }
}

export async function getSerologyList(item) {
 
    let routeName; 
    routeName = 'donor/serology_list'; 

    try {
        const { data } = await axios.get(routeName, {
            params: {
                name: item.name ?? '',
                factor: item.factor ?? '',
                kind_of_donor: item.kind_of_donor ?? '',
                unity: item.unity ?? ''
            }
        });

        return data.data;
    } catch (error) {
        return error;
    }
}

export async function getUnities() {
    return await request("GET", "/unities")
}

export async function getPatienteSituations() {
    return await request("GET", "/kind_of_donors")
}
export async function getFactors() {
    return await request("GET", "/blood_factors")
}
export async function getPatientsNotBloodGroups() {
    return await request("GET", "/donor/no_blood_group")
}
